import moment from 'moment';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCancellablePromise, useFileSaver } from '../../../hooks';
import { useAmplitudeTracker } from '../../../hooks/tracker';
import { EventService } from '../../../services';
export function useIndividualLeaderboardDownload() {
  const [downloading, setDownloading] = useState(false);
  const {
    t
  } = useTranslation();
  const {
    trackEvent
  } = useAmplitudeTracker();
  const {
    downloadXLSX
  } = useFileSaver();
  const {
    cancellablePromise
  } = useCancellablePromise();
  async function handleDownload(event, count, search = '') {
    if (!event.challengeTemplate) return;
    trackEvent('Event Leaderboard Exported', {
      display_type: 'individual',
      event_id: event.id,
      format: 'xlsx'
    });
    setDownloading(true);
    try {
      const nbPages = Math.ceil(count / 100);
      let progressValueHeader;
      if (event.challengeTemplate.type === 'cyclingDays') {
        progressValueHeader = t('commons.challenges.types.cycling_days');
      } else if (event.challengeTemplate.type === 'traveledDistance') {
        progressValueHeader = `${t('commons.distance')} (km)`;
      } else {
        progressValueHeader = t('commons.challenges.types.journeys');
      }
      const allItems = (await cancellablePromise(Promise.all(new Array(nbPages).fill(null).map((_, index) => EventService.getIndividualRanking(event.id, {
        page: index + 1,
        pageSize: 100,
        search
      }))))).flatMap(({
        items
      }) => items);
      downloadXLSX(`${[t('commons.events.details.leaderboard.title'), event.title].join('_').normalize('NFD').replace(/[\u0300-\u036f]/g, '').replace(/\s+/g, '_')}_${moment().format('YYYY-MM-DD')}.xlsx`, [t('commons.events.details.leaderboard.rank'), t('commons.events.details.leaderboard.participant'), 'Entreprise / Communauté', 'Taille', t('commons.commons.challenge_details.table.site'), progressValueHeader], allItems.map(({
        rank,
        user,
        group,
        progressValue
      }) => [rank, user.username, group.parent ? group.parent.title : group.title, group.parent ? group.parent.sizeRange ? `${group.parent.sizeRange.min}-${group.parent.sizeRange.max}` : '' : group.sizeRange ? `${group.sizeRange.min}-${group.sizeRange.max}` : '', group.parent ? group.title : '', event.challengeTemplate?.type === 'traveledDistance' ? Math.round(progressValue / 10) / 100 : progressValue]));
    } catch (err) {
      if (!(err instanceof Error) || err?.name !== 'CancelledPromiseError') {
        console.error(err);
      }
    }
    setDownloading(false);
  }
  return {
    downloading,
    handleDownload
  };
}